// import React from "react";
// import { Box, Typography, Avatar } from "@mui/material";
// import EmojiEventsIcon from "@mui/icons-material/EmojiEvents"; // Troféu
// import MilitaryTechIcon from "@mui/icons-material/MilitaryTech"; // Medalha
// import { useApp } from "../../context/AppContext";

// function PalanqueTop5({
//   mesSelecionado,
//   anoSelecionado,
//   filtroAtivo,
//   tipoRanking = "vgv", // "vgv" | "pontuacao_meta"
// }) {
//   const { corretores } = useApp();

//   // Configuração de tamanhos dos avatares (em pixels)
//   const avatarSizes = {
//     primeiro: 170, // Tamanho do avatar do 1º lugar
//     demais: 150, // Tamanho dos avatares dos demais lugares
//   };

//   // Configuração de layout dos cards
//   const cardConfig = {
//     width: 240, // Largura de todos os cards (mesmo width)
//     gap: 10, // Distância entre os cards (em pixels)
//   };

//   const formatarMoeda = (valor) => {
//     return new Intl.NumberFormat("pt-BR", {
//       style: "currency",
//       currency: "BRL",
//     }).format(valor);
//   };

//   const formatarNumero = (valor) => {
//     const n = typeof valor === "number" ? valor : parseInt(valor || 0, 10);
//     return (Number.isFinite(n) ? n : 0).toLocaleString("pt-BR");
//   };

//   // Filtrar e ordenar corretores - sempre mostrar apenas ativos no dashboard
//   const corretoresFiltrados = corretores
//     .filter((c) => {
//       // Sempre filtrar apenas corretores ativos no dashboard
//       if (!c.ativo) return false;
//       // Se o filtro for "Não", não mostrar nada (já que só mostramos ativos)
//       if (filtroAtivo === "Não") return false;
//       return true;
//     })
//     .map((corretor) => {
//       // Helpers (backward compatible)
//       const getVendaValor = (corretor, ano, mes) => {
//         const venda = corretor.vendas?.[ano]?.[mes];
//         if (!venda) return 0;
//         // Support both old format (number) and new format (object)
//         return typeof venda === "object" ? venda.valor || 0 : venda;
//       };

//       const getPontuacaoMetaMes = (corretor, ano, mes) => {
//         const venda = corretor.vendas?.[ano]?.[mes];
//         if (!venda || typeof venda !== "object") return 0;
//         const p = venda.pontuacao_meta ?? venda.pontuacaoMeta ?? 0;
//         return parseInt(p, 10) || 0;
//       };

//       // Totais por ano
//       const getVGVTotalAno = (corretor, ano) => {
//         if (!corretor.vendas?.[ano]) return 0;
//         return Object.values(corretor.vendas[ano]).reduce((total, venda) => {
//           const valor = typeof venda === "object" ? venda.valor || 0 : venda;
//           return total + valor;
//         }, 0);
//       };

//       const getPontuacaoMetaTotalAno = (corretor, ano) => {
//         if (!corretor.vendas?.[ano]) return 0;
//         return Object.values(corretor.vendas[ano]).reduce((total, venda) => {
//           if (!venda || typeof venda !== "object") return total;
//           const p = venda.pontuacao_meta ?? venda.pontuacaoMeta ?? 0;
//           return total + (parseInt(p, 10) || 0);
//         }, 0);
//       };

//       const isTodos = mesSelecionado === "Todos";

//       const vgv = isTodos
//         ? getVGVTotalAno(corretor, anoSelecionado)
//         : getVendaValor(corretor, anoSelecionado, mesSelecionado);

//       const pontuacaoMeta = isTodos
//         ? getPontuacaoMetaTotalAno(corretor, anoSelecionado)
//         : getPontuacaoMetaMes(corretor, anoSelecionado, mesSelecionado);

//       const valorRanking =
//         tipoRanking === "pontuacao_meta" ? pontuacaoMeta : vgv;

//       return { ...corretor, vgv, pontuacaoMeta, valorRanking };
//     })
//     .filter((c) => (c.valorRanking || 0) > 0)
//     .sort((a, b) => (b.valorRanking || 0) - (a.valorRanking || 0))
//     .slice(0, 5);

//   // Layout tipo pódio: 1º centro, 2º esquerda, 3º direita, 4º esquerda longe, 5º direita longe
//   // Cards alinhados lado a lado
//   // Ordem visual da esquerda para direita: 4º, 2º, 1º, 3º, 5º
//   // index: 0=1º, 1=2º, 2=3º, 3=4º, 4=5º
//   const getPosicaoStyle = (index) => {
//     // Calcula a largura total: 5 cards + 4 gaps
//     const totalWidth = cardConfig.width * 5 + cardConfig.gap * 4;
//     const startOffset = totalWidth / 2; // Distância do centro até o início

//     // Mapeia index de ranking para posição visual
//     // index: 0=1º, 1=2º, 2=3º, 3=4º, 4=5º
//     // visualPos: 0=4º, 1=2º, 2=1º(centro), 3=3º, 4=5º
//     const visualPositions = [2, 1, 3, 0, 4]; // 1º→centro, 2º→esq, 3º→dir, 4º→esq, 5º→dir
//     const visualPos = visualPositions[index];

//     // Calcula a posição left para cada posição visual
//     const leftPositions = [
//       `calc(50% - ${startOffset}px)`, // 0: 4º lugar (mais à esquerda)
//       `calc(50% - ${startOffset - (cardConfig.width + cardConfig.gap)}px)`, // 1: 2º lugar
//       `calc(50% - ${cardConfig.width / 2}px)`, // 2: 1º lugar (centro)
//       `calc(50% + ${cardConfig.width / 2 + cardConfig.gap}px)`, // 3: 3º lugar
//       `calc(50% + ${startOffset - cardConfig.width}px)`, // 4: 5º lugar (mais à direita)
//     ];

//     const heights = [400, 460, 550, 460, 400]; // Alturas: 4º, 2º, 1º, 3º, 5º (aumentado 4º e 5º)
//     const zIndexes = [1, 2, 3, 2, 1]; // Z-index: 4º, 2º, 1º, 3º, 5º

//     return {
//       position: "absolute",
//       left: leftPositions[visualPos],
//       bottom: 0,
//       width: cardConfig.width,
//       height: heights[visualPos],
//       zIndex: zIndexes[visualPos],
//     };
//   };

//   // Gradientes baseados na cor da borda do avatar (ranking)
//   // Gradiente fluido: cor do ranking até 36%, depois transição suave para cor escura
//   const getGradient = (ranking) => {
//     const coresRanking = {
//       1: { top: "#DAA520", bottom: "#8B6914" }, // douradoo autêntico (menos amarelo)
//       2: { top: "#C0C0C0", bottom: "#808080" }, // Prata
//       3: { top: "#CD7F32", bottom: "#8B4513" }, // Bronze
//       4: { top: "#808080", bottom: "#4B4B4B" }, // Cinza
//       5: { top: "#808080", bottom: "#4B4B4B" }, // Cinza
//     };

//     const cor = coresRanking[ranking] || coresRanking[1];

//     return `linear-gradient(180deg, ${cor.top} 0%, ${cor.top} 36%, ${cor.bottom} 100%)`;
//   };

//   const getImagemMedalhaLugar = (ranking) => {
//     if (ranking === 1) return "/trofeuouro2.png";
//     if (ranking === 2) return "/medprata.png";
//     if (ranking === 3) return "/medbronze.png";
//     return null;
//   };

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         mt: 2,
//       }}
//     >
//       {corretoresFiltrados.length > 0 ? (
//         <Box sx={{ position: "relative", height: 320, width: "100%" }}>
//           {corretoresFiltrados.map((corretor, index) => {
//             const style = getPosicaoStyle(index);
//             const isPrimeiro = index === 0;
//             const ranking = index + 1;
//             const medalhaLugarSrc = getImagemMedalhaLugar(ranking);

//             return (
//               <Box
//                 key={corretor.id}
//                 sx={{
//                   ...style,
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   overflow: "visible",
//                 }}
//               >
//                 {/* Avatar circular no topo */}
//                 <Box
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     width: "100%",
//                     zIndex: 10,
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       position: "relative",
//                       display: "inline-flex",
//                       borderRadius: "50%",
//                       // Reduzi um pouco o padding para a borda não ficar grossa demais,
//                       // mas você pode voltar para 10px se preferir
//                       padding: "7px",

//                       background:
//                         ranking === 1
//                           ? `linear-gradient(rgba(255, 215, 0, 0.2) 0%, rgba(255, 215, 0, 0.2) 100%),
//        repeating-linear-gradient(45deg, transparent, transparent 1px, rgba(255,255,255,0.1) 1px, rgba(255,255,255,0.1) 2px),
//        linear-gradient(90deg, #bf953f, #fcf6ba, #b38728, #fcf6ba, #aa771c)`
//                           : ranking === 2
//                             ? `linear-gradient(rgba(192, 192, 192, 0.1) 0%, rgba(192, 192, 192, 0.1) 100%),
//        repeating-linear-gradient(45deg, transparent, transparent 1px, rgba(255,255,255,0.1) 1px, rgba(255,255,255,0.1) 2px),
//        linear-gradient(90deg, #808080, #e6e6e6, #808080, #e6e6e6, #808080)`
//                             : ranking === 3
//                               ? `linear-gradient(rgba(205, 127, 50, 0.1) 0%, rgba(205, 127, 50, 0.1) 100%),
//        repeating-linear-gradient(45deg, transparent, transparent 1px, rgba(255,255,255,0.1) 1px, rgba(255,255,255,0.1) 2px),
//        linear-gradient(90deg, #8b4513, #e3af9a, #8b4513, #e3af9a, #8b4513)`
//                               : `linear-gradient(90deg, #4b4b4b, #808080, #4b4b4b)`, // 4º e 5º mais simples

//                       boxShadow:
//                         ranking <= 3
//                           ? `
//                                   0 8px 16px rgba(0,0,0,0.5),            /* Sombra projetada no pódio */
//                                   inset 0 3px 6px rgba(255,255,255,0.8), /* Luz no topo da borda */
//                                   inset 0 -3px 6px rgba(0,0,0,0.4)       /* Sombra na base da borda */
//                                 `
//                           : "0 4px 12px rgba(0,0,0,0.4)",

//                       // Acabamento: Uma linha fina interna que separa a foto do metal (vimos isso na sua imagem)
//                       "&::after": {
//                         content: '""',
//                         position: "absolute",
//                         inset: "7px", // Deve ser igual ao padding acima
//                         borderRadius: "50%",
//                         border: "1.5px solid rgba(0,0,0,0.1)",
//                         pointerEvents: "none",
//                       },

//                       // Brilho extra apenas para o Campeão (Ouro)
//                       "&::before":
//                         ranking === 1
//                           ? {
//                               content: '""',
//                               position: "absolute",
//                               top: "-4px",
//                               left: "-4px",
//                               right: "-4px",
//                               bottom: "-4px",
//                               borderRadius: "50%",
//                               background:
//                                 "radial-gradient(circle, rgba(255,215,0,0.4) 0%, transparent 70%)",
//                               zIndex: -1,
//                               animation: "pulse 2s infinite ease-in-out",
//                             }
//                           : {},

//                       // Animação opcional para o brilho do primeiro lugar
//                       "@keyframes pulse": {
//                         "0%": { transform: "scale(1)", opacity: 0.5 },
//                         "50%": { transform: "scale(1.1)", opacity: 0.8 },
//                         "100%": { transform: "scale(1)", opacity: 0.5 },
//                       },
//                     }}
//                   >
//                     <Avatar
//                       src={corretor.foto || undefined}
//                       alt={corretor.nome}
//                       sx={{
//                         width: isPrimeiro
//                           ? avatarSizes.primeiro
//                           : avatarSizes.demais,
//                         height: isPrimeiro
//                           ? avatarSizes.primeiro
//                           : avatarSizes.demais,
//                         border:
//                           ranking === 1
//                             ? "3px solid rgba(255, 255, 255, 0.3)" // Borda interna sutil para 1º
//                             : ranking === 2
//                               ? "3px solid rgba(255, 255, 255, 0.2)" // Borda interna para 2º
//                               : ranking === 3
//                                 ? "3px solid rgba(255, 255, 255, 0.2)" // Borda interna para 3º
//                                 : "2px solid rgba(255, 255, 255, 0.1)", // Borda interna para 4º e 5º
//                         boxShadow:
//                           ranking === 1
//                             ? "inset 0 0 15px rgba(255, 215, 0, 0.3), 0 0 10px rgba(255, 215, 0, 0.5)"
//                             : "0 2px 8px rgba(0, 0, 0, 0.2)",
//                         zIndex: 10,
//                         position: "relative",
//                         fontFamily: "Poppins",
//                       }}
//                     >
//                       {!corretor.foto && corretor.nome
//                         ? corretor.nome
//                             .split(" ")
//                             .map((n) => n[0])
//                             .join("")
//                             .substring(0, 2)
//                             .toUpperCase()
//                         : ""}
//                     </Avatar>
//                   </Box>
//                   {/* Badge circular com número do ranking */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       bottom: -8,
//                       left: "50%",
//                       transform: "translateX(-50%)",
//                       width: 28,
//                       height: 28,
//                       borderRadius: "50%",
//                       backgroundColor: "#1D2C40", // Azul escuro (cor secundária do tema douradoo)
//                       border: "1px solid #fff",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
//                       zIndex: 11,
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         fontSize: "12px",
//                         fontWeight: "bold",
//                         color: "#fff",
//                       }}
//                     >
//                       {ranking}
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {/* Retângulo com gradiente */}
//                 <Box
//                   sx={{
//                     width: "100%",
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                     background: getGradient(ranking),
//                     borderRadius: 2,
//                     overflow: "hidden",

//                     // Ajusta o topo para que o avatar sobreponha (metade do tamanho do avatar)
//                     mt: isPrimeiro
//                       ? `-${avatarSizes.primeiro / 2}px`
//                       : `-${avatarSizes.demais / 2}px`,
//                     pt: isPrimeiro
//                       ? `${avatarSizes.primeiro / 2 + 10}px`
//                       : `${avatarSizes.demais / 2 + 10}px`,
//                   }}
//                 >
//                   {/* Barra com ranking e nome */}
//                   <Box
//                     sx={{
//                       width: "90%",
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginLeft: "auto",
//                       marginRight: "auto",
//                     }}
//                   >
//                     {medalhaLugarSrc ? (
//                       <Box
//                         component="img"
//                         src={medalhaLugarSrc}
//                         alt={
//                           ranking === 1
//                             ? "1º lugar — ouro"
//                             : ranking === 2
//                               ? "2º lugar — prata"
//                               : "3º lugar — bronze"
//                         }
//                         sx={{
//                           display: "block",
//                           width: "auto",
//                           maxWidth: "94%",
//                           height: isPrimeiro ? 100 : 90,
//                           objectFit: "contain",
//                           filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.35))",
//                         }}
//                       />
//                     ) : (
//                       <Typography
//                         sx={{
//                           color: "#fff",
//                           fontWeight: 400,
//                           fontSize: "13px",
//                           textAlign: "center",
//                           fontFamily: "Poppins",
//                         }}
//                       >
//                         {ranking}° LUGAR
//                       </Typography>
//                     )}
//                     <Typography
//                       sx={{
//                         mt: 1,
//                         mb: 0,
//                         color: "#fff",
//                         fontWeight: 700,
//                         letterSpacing: 0.8,
//                         fontSize: isPrimeiro ? "26px" : "24px",
//                         textAlign: "center",
//                         textShadow: "2px 2px 4px rgba(0, 0, 0, 0.9)",
//                         fontFamily: "Poppins",
//                       }}
//                       noWrap
//                     >
//                       {corretor.nome}
//                     </Typography>
//                   </Box>

//                   {/* Total Vendido */}
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "flex-start",
//                       alignItems: "center",
//                       px: 1,
//                       pt: 0, // Padding top reduzido para ficar próximo do nome
//                       pb: 1,
//                       width: "100%",
//                     }}
//                   >
//                     {/* Ícone e valor vendido lado a lado */}
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         gap: ranking === 4 || ranking === 5 ? 0.5 : 1,
//                         flexWrap: "wrap", // Permite quebra de linha se necessário
//                       }}
//                     >
//                       {/* Ícone de troféu ou medalha ao lado do valor */}

//                       <Typography
//                         sx={{
//                           color: "#fff",
//                           fontWeight: "500",
//                           fontSize:
//                             ranking === 4 || ranking === 5
//                               ? "22px"
//                               : isPrimeiro
//                                 ? "22px"
//                                 : "22px",
//                           textAlign: "center",
//                           textShadow:
//                             "2px 2px 4px rgba(0, 0, 0, 0.9), 0 0 2px rgba(0, 0, 0, 0.7)",
//                           fontFamily: "Poppins",
//                         }}
//                       >
//                         {tipoRanking === "pontuacao_meta" ? (
//                           <>
//                             Pontos:{" "}
//                             <span style={{ fontWeight: "bold" }}>
//                               {formatarNumero(corretor.valorRanking)}
//                             </span>
//                           </>
//                         ) : (
//                           <>
//                             <span style={{ fontWeight: "bold" }}>
//                               {formatarMoeda(corretor.valorRanking)}
//                             </span>
//                           </>
//                         )}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             );
//           })}
//         </Box>
//       ) : (
//         <Typography
//           variant="body1"
//           sx={{ color: "text.secondary", textAlign: "center", py: 4 }}
//         >
//           Nenhum corretor encontrado para o período selecionado
//         </Typography>
//       )}
//     </Box>
//   );
// }

// export default PalanqueTop5;

import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { useApp } from "../../context/AppContext";
import { isCorretorSemPontuacao } from "../../utils/corretorUtils";

function PalanqueTop5({
  mesSelecionado,
  anoSelecionado,
  filtroAtivo,
  tipoRanking = "vgv",
}) {
  const { corretores } = useApp();

  const avatarSizes = {
    primeiro: 170,
    demais: 150,
  };

  const cardConfig = {
    width: 240,
    gap: 10,
  };

  const metalStyles = {
    1: {
      // Ouro
      bg: "linear-gradient(90deg, #9b7a2d 0%, #dec067 45%, #d1a545 70%, #9b7a2d 100%)",
      border: "#dec067",
      avatarBg: "linear-gradient(90deg, #bf953f, #fcf6ba, #b38728)",
    },
    2: {
      // Prata
      bg: "linear-gradient(90deg, #757575 0%, #e0e0e0 45%, #b8b8b8 70%, #757575 100%)",
      border: "#ffffff",
      avatarBg: "linear-gradient(90deg, #808080, #e6e6e6, #808080)",
    },
    3: {
      // Bronze
      bg: "linear-gradient(90deg, #804a32 0%, #d39371 45%, #b16d4d 70%, #804a32 100%)",
      border: "#e3af9a",
      avatarBg: "linear-gradient(90deg, #8b4513, #e3af9a, #8b4513)",
    },
    default: {
      // 4º e 5º (Aço escuro)
      bg: "linear-gradient(90deg, #2c2c2c 0%, #5a5a5a 45%, #464646 70%, #2c2c2c 100%)",
      border: "#888888",
      avatarBg: "linear-gradient(90deg, #4b4b4b, #808080, #4b4b4b)",
    },
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const formatarNumero = (valor) => {
    const n = typeof valor === "number" ? valor : parseInt(valor || 0, 10);
    return (Number.isFinite(n) ? n : 0).toLocaleString("pt-BR");
  };

  const corretoresFiltrados = corretores
    .filter((c) => c.ativo && filtroAtivo !== "Não" && !isCorretorSemPontuacao(c))
    .map((corretor) => {
      const isTodos = mesSelecionado === "Todos";
      const vendasAno = corretor.vendas?.[anoSelecionado] || {};
      const vendaMes = corretor.vendas?.[anoSelecionado]?.[mesSelecionado];

      const vgv = isTodos
        ? Object.values(vendasAno).reduce(
            (t, v) => t + (typeof v === "object" ? v.valor || 0 : v || 0),
            0,
          )
        : typeof vendaMes === "object"
          ? vendaMes.valor || 0
          : vendaMes || 0;

      const pontuacaoMeta = isTodos
        ? Object.values(vendasAno).reduce((t, v) => {
            if (!v || typeof v !== "object") return t;
            const p = v.pontuacao_meta ?? v.pontuacaoMeta ?? 0;
            return t + (parseInt(p, 10) || 0);
          }, 0)
        : (() => {
            if (!vendaMes || typeof vendaMes !== "object") return 0;
            const p = vendaMes.pontuacao_meta ?? vendaMes.pontuacaoMeta ?? 0;
            return parseInt(p, 10) || 0;
          })();

      const valorRanking =
        tipoRanking === "pontuacao_meta" ? pontuacaoMeta : vgv;

      return { ...corretor, valorRanking };
    })
    .filter((c) => c.valorRanking > 0)
    .sort((a, b) => b.valorRanking - a.valorRanking)
    .slice(0, 5);

  const getPosicaoStyle = (index) => {
    const visualPositions = [2, 1, 3, 0, 4];
    const visualPos = visualPositions[index];
    const heights = [340, 400, 480, 400, 340];
    const totalWidth = cardConfig.width * 5 + cardConfig.gap * 4;

    return {
      position: "absolute",
      left: `calc(50% - ${totalWidth / 2}px + ${visualPos * (cardConfig.width + cardConfig.gap)}px)`,
      bottom: 0,
      width: cardConfig.width,
      height: heights[visualPos],
      zIndex: [3, 2, 2, 1, 1][index],
    };
  };

  const getImagemMedalhaLugar = (ranking) => {
    if (ranking === 1) return "/ou.png";
    if (ranking === 2) return "/medprata.png";
    if (ranking === 3) return "/medbronze.png";
    return null;
  };

  return (
    <Box sx={{ position: "relative", mt: 10, height: 600, width: "100.5%" }}>
      {corretoresFiltrados.map((corretor, index) => {
        const ranking = index + 1;
        const config = metalStyles[ranking] || metalStyles.default;
        const style = getPosicaoStyle(index);
        const isPrimeiro = index === 0;

        return (
          <Box
            key={corretor.id}
            sx={{
              ...style,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* 1. AVATAR COM BORDA METÁLICA */}
            <Box
              sx={{
                position: "relative",
                p: "8px",
                background: config.avatarBg,
                borderRadius: "50%",
                boxShadow:
                  "0 10px 20px rgba(0,0,0,0.4), inset 0 2px 5px rgba(255,255,255,0.5)",
                zIndex: 10,
              }}
            >
              <Avatar
                src={corretor.foto}
                sx={{
                  width: isPrimeiro ? avatarSizes.primeiro : avatarSizes.demais,
                  height: isPrimeiro
                    ? avatarSizes.primeiro
                    : avatarSizes.demais,
                  border: "2px solid rgba(0,0,0,0.1)",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: -10,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 30,
                  height: 30,
                  bgcolor: "#1D2C40",
                  border: "2px solid #fff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 11,
                }}
              >
                <Typography
                  sx={{ fontSize: 14, fontWeight: "bold", color: "#fff" }}
                >
                  {ranking}
                </Typography>
              </Box>
            </Box>

            {/* 2. COLUNA DO PALANQUE */}
            <Box
              sx={{
                width: "100%",
                flex: 1,
                mt: isPrimeiro
                  ? `-${avatarSizes.primeiro / 2}px`
                  : `-${avatarSizes.demais / 2}px`,
                pt: isPrimeiro
                  ? `${avatarSizes.primeiro / 2 + 12}px`
                  : `${avatarSizes.demais / 2 + 12}px`,
                background: config.bg,
                borderRadius: "12px 12px 0 0",
                boxShadow: `inset 0 1px 0 0 ${config.border}, 5px 0 15px rgba(0,0,0,0.3)`,
                position: "relative",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                "&::before": {
                  // A TEXTURA ESCOVADA
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  opacity: 0.15,
                  backgroundImage:
                    "repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(255,255,255,0.4) 1px, rgba(255,255,255,0.4) 2px)",
                },
              }}
            >
              <Box sx={{ zIndex: 2, textAlign: "center", px: 2 }}>
                {getImagemMedalhaLugar(ranking) && (
                  <Box
                    component="img"
                    src={getImagemMedalhaLugar(ranking)}
                    sx={{
                      height: isPrimeiro ? 120 : 90,
                      mb: 1,
                      filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.4))",
                    }}
                  />
                )}
                <Typography
                  sx={{
                    color: "#fff",
                    fontWeight: 400,
                    fontSize: isPrimeiro ? "24px" : "22px",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.8)",
                    fontFamily: "Poppins",
                  }}
                  noWrap
                >
                  {corretor.nome}
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    mt: 0,
                    fontWeight: 600,
                    fontSize: "29px",
                    textShadow: "1px 1px 3px rgba(0,0,0,0.8)",
                  }}
                >
                  {tipoRanking === "pontuacao_meta"
                    ? `Meta: ${formatarNumero(corretor.valorRanking)}`
                    : formatarMoeda(corretor.valorRanking)}
                </Typography>
              </Box>
            </Box>

            {/* 3. BASE (O DEGRAU DE BAIXO) */}
            <Box
              sx={{
                width: "108%",
                height: 25,
                background: config.bg,
                borderRadius: "4px 4px 0 0",
                boxShadow: `inset 0 1px 0 0 ${config.border}, 0 5px 15px rgba(0,0,0,0.5)`,
                zIndex: 5,
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  width: "100%",
                  height: "2px",
                  bgcolor: "rgba(255,255,255,0.2)",
                },
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
}

export default PalanqueTop5;
